import { Injectable, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
@Injectable()
export class NotificationService implements OnDestroy {
  private subs = new Subscription();
  constructor(public snackBar: MatSnackBar) { }
  notify(message: string,type: string="info", duration: number = 6000, action: string = "Dismiss") {
    let alertClass= "custom-info";
    switch (type) {
      case "warn":
        alertClass = "custom-warn";
        break;
      case "error":
        alertClass = "custom-error";
        break;
      case "success":
        alertClass = "custom-success";
        break;
      case "info":
        alertClass = "custom-info";
        break;

    }
    let sb = this.snackBar.open(message, action, {
      duration: duration,
      panelClass: [alertClass]



    });
    const actionSub = sb.onAction().subscribe(() => {
      sb.dismiss();
    });
    this.subs.add(actionSub);
    

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

